import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as faqCategoriesActions from '../actions/faq-categories.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { FaqCategoriesService } from '../../services';
import { Go } from 'src/app/store';

@Injectable()
export class FaqCategoriesEffects {
  private actions$ = inject(Actions);
  private faqService = inject(FaqCategoriesService);

  LoadFaqCategories$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(faqCategoriesActions.LoadFaqCategories),
      switchMap(() =>
        this.faqService.getFaqCategories().pipe(
          map(categories => {
            if (!categories) {
              return faqCategoriesActions.LoadFaqCategoriesFail({ error: { status: 404 } });
            }
            return faqCategoriesActions.LoadFaqCategoriesSuccess({ categories });
          }),
          catchError(error => of(faqCategoriesActions.LoadFaqCategoriesFail({ error })))
        )
      )
    );
  });
}
